import React from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";
import logo from "./assets/logo.png";

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <div className="home-card">
        {/* 🔥 LOGO */}
        <div className="home-logo">
          <img src={logo} alt="Logo" />
        </div>

        <h1>Bienvenue</h1>
        <p>Choisissez votre accès</p>

        <div className="home-buttons">
          <button
            className="home-btn member"
            onClick={() => navigate("/member-login")}
          >
            👤 Espace adhérents
          </button>

          <button
            className="home-btn admin"
            onClick={() => navigate("/admin-login")}
          >
            🏢 Espace salariés et bénévoles
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;
